import * as React from 'react';
import Registry from '../../../global/Registry';

interface Props {
}

interface State {
	showInstructions: boolean;
}

export default class ChoiceExerciseComponent extends React.Component<Props, State> {

	public constructor () {
		super();
		this.state = { showInstructions: false };
	}

	componentWillMount () {
		const KEY = 'numberOfChoiceExercisesSeen' + Registry.getInstance().me.getId().getValue();

		const numberOfBooleanExercisesSeen = localStorage.getItem(KEY) === null ? 0 : Number(localStorage.getItem(KEY));

		this.setState({ showInstructions: numberOfBooleanExercisesSeen < 3 });

		localStorage.setItem(KEY, String(numberOfBooleanExercisesSeen + 1));
	}

	render () {
		return (
			<div>
				{this.state.showInstructions && <p className='exercise-instruction'>Click on the <strong className='question-mark'>?</strong> below and replace it with the correct symbol.</p>}
				{this.props.children}
			</div>
		);
	}
}


// WEBPACK FOOTER //
// ./code/project/pages/components/exercises/ChoiceExerciseComponent.tsx